import { Component, Input, OnInit } from '@angular/core';
import { DialogRef } from '@ngneat/dialog';

@Component({
  selector: 'app-modal-forbidden-email',
  templateUrl: './modal-forbidden-email.component.html',
  styleUrls: ['./modal-forbidden-email.component.scss']
})
export class ModalForbiddenEmailComponent implements OnInit {
  @Input() domain: any;

  constructor(public ref: DialogRef) { }

  ngOnInit() { }

  closeModal() {
    this.ref.close();
  }

}
